import React, { PropTypes } from 'react';


const propTypes = {
  image: PropTypes.object.isRequired,
};

const Image = (props) => {
  const className = props.image.extraClasses
  ? `ui ${props.image.extraClasses} image`
  : 'ui image';

  return (
    <div className={className}>
      <img src={props.image.src} alt={props.image.alt} />
    </div>
  );
};

Image.propTypes = propTypes;

export default Image;



/** WEBPACK FOOTER **
 ** ./src/components/layout/sui/image/Image.js
 **/